<template>
  <div class="paper-bags-with-handles with-slider">
    <slider-select
      v-if="fields[PaperBagsWithHandlesFields.type].options?.length"
      v-model="form.type"
      class="main-slider"
    >
      <slider-select-option
        v-for="option in fields[PaperBagsWithHandlesFields.type].options"
        :key="option.value"
        :value="option.value"
        :label="option.title"
        :image-src="uploadsUrl(option?.thumbnail?.data?.attributes.url || '')"
      />
    </slider-select>
    <i-form
      v-scroll-to-invalid
      class="paper-bags-with-handles-form w-full"
      name="paper-bags-with-handles-form"
      @submit="handleSubmit"
    >
      <div v-if="labels[PaperBagsWithHandlesLabels.type]" class="type">
        <strapi-label :label="labels[PaperBagsWithHandlesLabels.type]" />
        <div class="form-field-group">
          <zaproo-select
            v-if="fields[PaperBagsWithHandlesFields.type]"
            v-model="form.type"
            :removable="false"
            searchable
            highlight
            :no-result-label="$t('No results found')"
            no-result-class="text-neutral-900/50 text-center !py-2 !px-4"
            name="type"
            :rules="fieldRules[PaperBagsWithHandlesFields.type]"
            :placeholder="$t('Select option')"
            dropdown-classes="py-2 mt-2"
            class="form-field checkmark"
          >
            <template #label>
              <special-order-form-input-label
                :field="fields[PaperBagsWithHandlesFields.type]"
              />
            </template>

            <zaproo-select-option
              v-for="option in fields[PaperBagsWithHandlesFields.type].options"
              :key="option.value"
              :value="option.value"
              :label="option.title"
            />
          </zaproo-select>
        </div>
      </div>
      <div
        v-if="fields[PaperBagsWithHandlesFields.type].options?.length"
        class="form-slider"
      >
        <slider-select v-model="form.type">
          <slider-select-option
            v-for="option in fields[PaperBagsWithHandlesFields.type].options"
            :key="option.value"
            :value="option.value"
            :label="option.value"
            :image-src="
              uploadsUrl(option?.thumbnail?.data?.attributes.url || '')
            "
          />
        </slider-select>
      </div>
      <div
        v-if="labels[PaperBagsWithHandlesLabels.dimensions]"
        class="dimensions mt-6"
      >
        <strapi-label :label="labels[PaperBagsWithHandlesLabels.dimensions]" />
        <div class="form-field-third">
          <zaproo-input
            v-for="d in dimensions"
            :key="d.name"
            v-model="form[d.name]"
            type="number"
            :name="d.name"
            :placeholder="d.placeholder"
            :description="d.description"
            class="form-field"
          >
            <template #label>
              <special-order-form-input-label :field="d.field" />
            </template>
          </zaproo-input>
        </div>
      </div>
      <div v-if="labels[PaperBagsWithHandlesLabels.color]" class="color mt-6">
        <strapi-label :label="labels[PaperBagsWithHandlesLabels.color]" />
        <div class="form-field-group">
          <zaproo-select
            v-if="fields[PaperBagsWithHandlesFields.mainColor]"
            v-model="form.mainColor"
            :removable="false"
            name="mainColor"
            :rules="fieldRules[PaperBagsWithHandlesFields.mainColor]"
            :placeholder="$t('Select option')"
            dropdown-classes="py-2 mt-2"
            class="form-field checkmark"
          >
            <template #label>
              <special-order-form-input-label
                :field="fields[PaperBagsWithHandlesFields.mainColor]"
              />
            </template>

            <zaproo-select-option
              v-for="option in fields[PaperBagsWithHandlesFields.mainColor]
                .options"
              :key="option.value"
              :value="option.value"
            >
              {{ option.title }}
            </zaproo-select-option>
          </zaproo-select>
          <zaproo-input
            v-if="isOtherSelect"
            v-model="form.otherMainColor"
            name="otherMainColor"
            :placeholder="
              fields[PaperBagsWithHandlesFields.otherMainColor].placeholder
            "
            :description="
              fields[PaperBagsWithHandlesFields.otherMainColor].description
            "
            class="form-field"
          >
            <template #label>
              <special-order-form-input-label
                :field="fields[PaperBagsWithHandlesFields.otherMainColor]"
              />
            </template>
          </zaproo-input>
        </div>
      </div>
      <div v-if="labels[PaperBagsWithHandlesLabels.print]" class="print mt-6">
        <strapi-label :label="labels[PaperBagsWithHandlesLabels.print]" />
        <div class="form-field-group">
          <zaproo-select
            v-if="fields[PaperBagsWithHandlesFields.printColors]"
            v-model="form.printColors"
            :removable="false"
            name="printColors"
            :rules="fieldRules[PaperBagsWithHandlesFields.printColors]"
            :placeholder="$t('Select option')"
            dropdown-classes="py-2 mt-2"
            class="form-field checkmark"
          >
            <template #label>
              <special-order-form-input-label
                :field="fields[PaperBagsWithHandlesFields.printColors]"
              />
            </template>

            <zaproo-select-option
              v-for="option in fields[PaperBagsWithHandlesFields.printColors]
                .options"
              :key="option.value"
              :value="option.value"
            >
              {{ option.title }}
            </zaproo-select-option>
          </zaproo-select>
          <zaproo-select
            v-if="
              isFrontSideSelect && fields[PaperBagsWithHandlesFields.printArea]
            "
            v-model="form.printArea"
            :removable="false"
            name="printArea"
            :rules="fieldRules[PaperBagsWithHandlesFields.printArea]"
            :placeholder="$t('Select option')"
            dropdown-classes="py-2 mt-2"
            class="form-field checkmark"
          >
            <template #label>
              <special-order-form-input-label
                :field="fields[PaperBagsWithHandlesFields.printArea]"
              />
            </template>

            <zaproo-select-option
              v-for="option in fields[PaperBagsWithHandlesFields.printArea]
                .options"
              :key="option.value"
              :value="option.value"
            >
              {{ option.title }}
            </zaproo-select-option>
          </zaproo-select>
        </div>
        <div class="form-field-group">
          <zaproo-select
            v-if="fields[PaperBagsWithHandlesFields.printColorsBack]"
            v-model="form.printColorsBack"
            :removable="false"
            name="printColorsBack"
            :rules="fieldRules[PaperBagsWithHandlesFields.printColorsBack]"
            :placeholder="$t('Select option')"
            dropdown-classes="py-2 mt-2"
            class="form-field checkmark"
          >
            <template #label>
              <special-order-form-input-label
                :field="fields[PaperBagsWithHandlesFields.printColorsBack]"
              />
            </template>

            <zaproo-select-option
              v-for="option in fields[
                PaperBagsWithHandlesFields.printColorsBack
              ].options"
              :key="option.value"
              :value="option.value"
            >
              {{ option.title }}
            </zaproo-select-option>
          </zaproo-select>
          <zaproo-select
            v-if="
              isBackSideSelect &&
              fields[PaperBagsWithHandlesFields.printAreaBack]
            "
            v-model="form.printAreaBack"
            :removable="false"
            name="printAreaBack"
            :rules="fieldRules[PaperBagsWithHandlesFields.printAreaBack]"
            :placeholder="$t('Select option')"
            dropdown-classes="py-2 mt-2"
            class="form-field checkmark"
          >
            <template #label>
              <special-order-form-input-label
                :field="fields[PaperBagsWithHandlesFields.printAreaBack]"
              />
            </template>

            <zaproo-select-option
              v-for="option in fields[PaperBagsWithHandlesFields.printAreaBack]
                .options"
              :key="option.value"
              :value="option.value"
            >
              {{ option.title }}
            </zaproo-select-option>
          </zaproo-select>
        </div>
        <div
          v-if="isFrontSideSelect || isBackSideSelect"
          class="form-field-group"
        >
          <zaproo-file-input
            v-model="form.designFile"
            class="form-file-field mt-3"
            name="designFiles"
            multiple
            :rules="fieldRules[PaperBagsWithHandlesFields.designFile]"
            :total-size-of-files="INPUT_FILE_TOTAL_SIZE"
            :placeholder="
              fields[PaperBagsWithHandlesFields.designFile].placeholder
            "
          >
            <template #label>
              <special-order-form-input-label
                :field="fields[PaperBagsWithHandlesFields.designFile]"
              />
            </template>
            <template #removeFileText>
              <icons-icon-trash />
              {{ $t("Remove") }}
            </template>
            <template #fileError="{ errors, clear }">
              <div class="mb-2 grid grid-cols-1 gap-2">
                <file-input-error-notification
                  :clear="clear"
                  :errors="errors"
                />
              </div>
            </template>
          </zaproo-file-input>
        </div>
      </div>
      <special-order-form-general-contacts-part
        v-model="form"
        class="general-contacts-form"
        :loading="loading"
      >
        <zaproo-input
          v-model="form.amountPcs"
          type="number"
          name="amountPcs"
          :rules="fieldRules[PaperBagsWithHandlesFields.amountPcs]"
          :placeholder="
            fields[PaperBagsWithHandlesFields.amountPcs].placeholder
          "
          :description="
            fields[PaperBagsWithHandlesFields.amountPcs].description
          "
          class="form-field"
        >
          <template #label>
            <special-order-form-input-label
              :field="fields[PaperBagsWithHandlesFields.amountPcs]"
            />
          </template>
        </zaproo-input>
      </special-order-form-general-contacts-part>
    </i-form>
  </div>
</template>

<script setup lang="ts">
import { Form as IForm, FormActions } from "vee-validate";
import SpecialOrderFormInputLabel from "../../SpecialOrderForm/SpecialOrderFormInputLabel.vue";
import {
  PaperBagsWithHandlesFields,
  PaperBagsWithHandlesLabels,
} from "./types";
import { dimensionsInput } from "./variables";
import {
  StrapiField,
  StrapiLabel as StrapiLabelType,
  StrapiSpecialOrders,
} from "~/types/strapi";
import { getFieldDefaultModel } from "~/modules/special-orders/helpers";
import StrapiLabel from "~/components/strapi/components/shared/StrapiLabel.vue";
import { INPUT_FILE_TOTAL_SIZE } from "~/modules/special-orders/variables";
import FileInputErrorNotification from "~/modules/special-orders/components/SpecialOrderForm/FileInputErrorNotification.vue";
import { useFormFieldCleaner } from "~/modules/special-orders/composables/useFormFieldCleaner";

const props = defineProps<{
  specialOrder: StrapiSpecialOrders;
}>();

const { uploadsUrl } = useStrapiExtend();

const { collection: labelCollection } =
  useSpecialOrderUidDictionary<StrapiLabelType>(props.specialOrder.labels);
const { collection: fieldsCollection } =
  useSpecialOrderUidDictionary<StrapiField>(props.specialOrder.fields);

const { sendRequest, loading } = useSpecialOrdersSubmit(props.specialOrder);

const labels = computed(() => labelCollection(PaperBagsWithHandlesLabels));
const fields = computed(() => fieldsCollection(PaperBagsWithHandlesFields));
const fieldRules = useSpecialOrderFieldRules<typeof PaperBagsWithHandlesFields>(
  fields.value,
);

const isOtherSelect = computed(() => form.value.mainColor === "other");
const isFrontSideSelect = computed(() => form.value.printColors !== "0");
const isBackSideSelect = computed(() => form.value.printColorsBack !== "0");

const form = ref<ReturnType<typeof resetForm>>(resetForm());

function resetForm() {
  return {
    type: getFieldDefaultModel(fields.value[PaperBagsWithHandlesFields.type]),
    length: getFieldDefaultModel(
      fields.value[PaperBagsWithHandlesFields.length],
    ),
    width: getFieldDefaultModel(fields.value[PaperBagsWithHandlesFields.width]),
    folding: getFieldDefaultModel(
      fields.value[PaperBagsWithHandlesFields.folding],
    ),
    mainColor: getFieldDefaultModel(
      fields.value[PaperBagsWithHandlesFields.mainColor],
    ),
    otherMainColor: getFieldDefaultModel(
      fields.value[PaperBagsWithHandlesFields.otherMainColor],
    ),
    printColors: getFieldDefaultModel(
      fields.value[PaperBagsWithHandlesFields.printColors],
    ),
    printArea: getFieldDefaultModel(
      fields.value[PaperBagsWithHandlesFields.printArea],
    ),
    printColorsBack: getFieldDefaultModel(
      fields.value[PaperBagsWithHandlesFields.printColorsBack],
    ),
    printAreaBack: getFieldDefaultModel(
      fields.value[PaperBagsWithHandlesFields.printAreaBack],
    ),
    designFile: [],
    amountPcs: getFieldDefaultModel(
      fields.value[PaperBagsWithHandlesFields.amountPcs],
    ),
    email: "",
    phone: "",
    additionalInfo: "",
  };
}

const dimensions = computed(() =>
  dimensionsInput.map((dimension) => ({
    name: dimension,
    required: fields.value[PaperBagsWithHandlesFields[dimension]],
    placeholder:
      fields.value[PaperBagsWithHandlesFields[dimension]].placeholder,
    description:
      fields.value[PaperBagsWithHandlesFields[dimension]].description,
    field: fields.value[PaperBagsWithHandlesFields[dimension]],
  })),
);

async function handleSubmit(
  _: Record<string, unknown>,
  { resetForm: reset }: FormActions<Record<string, unknown>>,
) {
  await sendRequest(form.value);
  reset();
  form.value = resetForm();
}

useFormFieldCleaner(
  {
    otherMainColor: {
      default: () =>
        getFieldDefaultModel(
          fields.value[PaperBagsWithHandlesFields.otherMainColor],
        ),
      ref: isOtherSelect,
    },
    printArea: {
      default: () =>
        getFieldDefaultModel(
          fields.value[PaperBagsWithHandlesFields.printArea],
        ),
      ref: isFrontSideSelect,
    },
    printAreaBack: {
      default: () =>
        getFieldDefaultModel(
          fields.value[PaperBagsWithHandlesFields.printArea],
        ),
      ref: isBackSideSelect,
    },
    designFile: {
      default: () => [],
      ref: computed(() => isBackSideSelect.value || isFrontSideSelect.value),
    },
  },
  form,
);
</script>
